export const DOT_WIDTH_MAP = {
  32: 320,
  42: 420,
  48: 480,
  54: 540,
  64: 640,
  76: 760,
  10: 1000,
  12: 1200,
  14: 1400,
  16: 1600,
  18: 1800,
  20: 2000,
  22: 2200,
  24: 2400
};
export const DOT_WIDTH_ALIASES = [32, 42, 48, 54, 64, 76, 10, 12, 14, 16, 18, 20, 22, 24];
export const DOT_WIDTHS = [320, 420, 480, 540, 640, 760, 1000, 1200, 1400, 1600, 1800, 2000, 2200, 2400];
export const DOT_WIDTH_LENGTH = 14;
export const DOT_TRANS_PROPERTIES = {
  /**
   * opacity
   */
  o: {
    opacity: 0
  },
  /**
   * top
   */
  t: {
    transform: 'translateY(-100%)'
  },
  /**
   * right
   */
  r: {
    transform: `translateX(100%)`
  },
  /**
   * bottom
   */
  b: {
    transform: `translateY(100%)`
  },
  /**
   * left
   */
  l: {
    transform: `translateX(-100%)`
  },
  /**
   * up
   */
  u: {
    transform: `scale(1.4)`
  },
  /**
   * down
   */
  d: {
    transform: `scale(0.6)`
  },
  /**
   * flip
   */
  f: {
    transform: 'rotateY(0.5turn)'
  },
  /**
   * spin
   */
  s: {
    transform: 'rotate(-90deg)'
  }
};